import React from "react";

import {CircularProgress, Stack} from "@mui/joy";
import Button from "@mui/joy/Button";
import Divider from "@mui/joy/Divider";
import Chip from "@mui/joy/Chip";

// components
import CommentForm from "./CommentForm";
import CommentList from "./CommentList";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import CommentAttachmentAdd from "./CommentAttachmentAdd";
import CommentAttachment from "./CommentAttachment";
import BaseApi from "../../utils/BaseApi";

// Icons
import TelegramIcon from '@mui/icons-material/Telegram';


export async function retrieveCommentXtypes(appName, appId){
    let mateXtypes = ['COMMON', ]
    let xtypes = {}
    if (appName === 'Opportunity'){
        const api = new BaseApi();
        let url = 'comment/xtypes/';
        let params = {}
        let response = await api.get(url, params);
        xtypes = response.data
        url = 'opp_team/comment_xtypes/';
        params = {
            opportunity: appId,
        };
        response = await api.get(url, params);
        mateXtypes = response.data
    }
    return [xtypes, mateXtypes]
}


class CommentSidebar extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.editor = React.createRef();
        this.list = React.createRef();
        this.state = {
            comment_form: <CommentForm
                ref={this.editor}
                appName={this.props.appName}
                appId={this.props.appId}
                xtype={'COMMON'}
            />,
            attachments: [],
            ready: true,
            xtype: 'ALL',
            listXtypes: ['COMMON', ],
            mateXtypes: ['COMMON', ],
            xtypes: null,
        };
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            this.forceUpdate()
        }
    }

    async componentDidMount() {
        await this.retrieveCommentXtypes();
    }

    async setXtype(key){
        let listXtypes
        let xtype
        if (key === 'ALL'){
            listXtypes = this.state.mateXtypes
            xtype = 'COMMON'
        }
        else {
            listXtypes = [key, ]
            xtype = key
        }
        this.setState(
            {
                listXtypes: listXtypes,
                xtype: key,
                comment_form: <CommentForm
                    ref={this.editor}
                    appName={this.props.appName}
                    appId={this.props.appId}
                    xtype={xtype}
                />
            }
        )
    }

    async retrieveCommentXtypes(){
        let [xtypes, mateXtypes] = await retrieveCommentXtypes(
            this.props.appName,
            this.props.appId
        )
        this.setState(
            {
                xtypes: xtypes,
                mateXtypes: mateXtypes,
                listXtypes: mateXtypes,
            }
        );
    }

    async postComment(){
        this.setState(
            {ready: false,}
        );
        let data = {
            type: "comment",
            content: this.editor.current.state.value,
            reply_to: this.editor.current.state.replyTo?.id,
            related_app: this.props.appName,
            related_app_id: this.props.appId,
            xtype: this.state.xtype === 'ALL'?'COMMON':this.state.xtype,
        };
        if (this.state.attachments.length){
            data.attachments = this.state.attachments
        }
        const api = new BaseApi();
        const url = 'comment/'
        let response = await api.post(
            url,
            data
        );
        if (response.status === 201){
            let r = (Math.random() + 1).toString(36).substring(7);
            this.list.current.addComment(response.data?.id)
            this.setState(
            {
                    comment_form: <CommentForm
                        ref={this.editor}
                        initialValue={''}
                        key={r}
                        appName={this.props.appName}
                        appId={this.props.appId}
                        xtype={this.state.xtype}
                    />,
                    attachments: [],
                    ready: true,
                },
            );
        }
    }

    reply(comment) {
        this.editor.current.reply(comment)
    }

    addAttachment(id){
        let attachments = this.state.attachments;
        attachments.push(id)
        this.setState({
            attachments: attachments
        })
    }

    render() {
        if (!this.state.comment_form || !this.state.xtypes) {
            return (<CircularProgress />)
        }
        return(
            <Stack
                sx={{
                    flexDirection: 'column',
                    width: '100%',
                    height: this.props.height?this.props.height:'100%',
                    maxHeight: '100%',
                    alignItems: 'stretch',
                    justifyContent: "space-between",
                    overflowY: 'hidden',
                }}
            >
                {
                    this.props.appName === 'Opportunity'?
                        <Stack
                            direction={'row'}
                            spacing={1}
                            sx={{
                                width: '100%',
                                display: 'flex',
                                mb: 1,
                            }}
                        >
                            <Chip
                                color={'primary'}
                                onClick={this.setXtype.bind(this, 'ALL')}
                                variant={this.state.xtype === 'ALL'?'solid':'soft'}
                                size={'sm'}
                                key={'CommentXtype'+this.props.appId+'ALL'}
                            >
                                Все
                            </Chip>
                            {Object.keys(this.state.xtypes).map((key) => (
                                this.state.mateXtypes.includes(key)?
                                    <Chip
                                        color={'primary'}
                                        onClick={this.setXtype.bind(this, key)}
                                        variant={this.state.xtype === key?'solid':'soft'}
                                        size={'sm'}
                                        key={'CommentXtype'+this.props.appId+key}
                                    >
                                        #{this.state.xtypes[key]}
                                    </Chip>:
                                    null
                            ))}
                        </Stack>:
                        null
                }

                <CommentList
                    key={'CommentList_'+this.props.appName+this.props.appId+this.state.xtype}
                    replyCallBack={this.reply.bind(this)}
                    appId={this.props.appId}
                    appName={this.props.appName}
                    listXtypes={this.state.listXtypes}
                    ref={this.list}
                    reverse={this.props.reverse}
                    xtype={this.state.xtype}
                />
                {
                    this.props.appName === 'Opportunity' && this.state.xtype === 'ALL'?
                        null:
                        <Stack
                            spacing={1}
                            sx={{
                                width: '100%',
                                display: 'flex',
                                flexGrow: 1,
                            }}
                        >
                            <Divider/>
                            {this.state.comment_form}
                            <Stack
                                spacing={1}
                                direction={'row'}
                                sx={{
                                    flexWrap: 'wrap',
                                }}
                            >
                                <Button
                                    disabled={!this.state.ready}
                                    aria-label="commentSubmit"
                                    size={'sm'}
                                    color="primary"
                                    onClick={this.postComment.bind(this)}
                                    variant={'soft'}
                                >
                                    <TelegramIcon sx={{mr: 2}}/> Отправить
                                </Button>
                                <CommentAttachmentAdd
                                    callBack={this.addAttachment.bind(this)}
                                    appId={this.props.appId}
                                    appName={this.props.appName}
                                    flat={true}
                                />
                                {
                                    this.state.attachments.map(
                                        (a) => (
                                            <CommentAttachment
                                                id={a}
                                            />
                                        )
                                    )
                                }
                            </Stack>
                        </Stack>
                }

            </Stack>
        )
    }
}

export default CommentSidebar;
